import type { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import type { ResponsiveStyleValue } from '@mui/system';
import type { IconName } from '../../icon/Icon';

export enum ButtonIconPosition {
  LEFT = 'Left',
  RIGHT = 'Right',
}

export enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  GHOST = 'ghost',
  INLINE = 'inline',
}

export enum ButtonSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
}

type BaseButtonProps = Omit<
  MuiButtonProps,
  'startIcon' | 'endIcon' | 'loading' | 'size' | 'variant'
>;

export interface ButtonProps extends BaseButtonProps {
  externalLink?: boolean;
  isLoading?: boolean;
  variant?: ButtonVariant;
  size?: ResponsiveStyleValue<ButtonSize>;
  iconName?: IconName;
  iconPosition?: ButtonIconPosition;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
}
